import { db } from '../config/firebase';

const collection = 'projects';

async function retrieveAll() {
  let query = db.collection(collection);

  query = query.orderBy('order', 'asc');

  const querySnapshot = await query.get();

  let results = [];
  querySnapshot.forEach(doc => {
    results.push({
      id: doc.id,
      ...doc.data()
    });
  });

  return results;
}

export default { retrieveAll }